import { babyface } from '../CDNUrl';

const EVENT_BANNER_URI = `${babyface}/event/event_banner`;
const EVENT_DETAIL_URI = `${babyface}/event_detail`;
const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const HOME_BANNER_REVIEW_CONTEST = {
  src: `${HOME_BANNER_URI}_after_birth_review_contest.jpg`,
  alt: `생후 후기 리뷰 콘테스트 이벤트 홈배너`,
};

export const EVENT_BANNER_REVIEW_CONTEST = {
  src: `${EVENT_BANNER_URI}_after_birth_review_contest.jpg`,
  alt: `생후 후기 리뷰 콘테스트 이벤트 배너`,
};

export const EVENT_DETAIL_REVIEW_CONTEST = {
  src: `${EVENT_DETAIL_URI}/after_birth_review_contest.jpg`,
  alt: `생후 후기 리뷰 콘테스트 이벤트 안내사항`,
};

export const EVENT_DETAIL_BUTTON_ROUTE = {
  src: `${EVENT_DETAIL_URI}/route_after_birth_review_contest.png`,
  alt: '마이페이지 리뷰 관리 페이지로 이동',
};

export const REVIEW_BANNER_REVIEW_CONTEST = {
  src: `${EVENT_BANNER_URI}_after_birth_review_contest_review_page.jpg`,
  alt: `생후 후기 리뷰 콘테스트 이벤트 배너`,
};
